import {useParams} from "react-router-dom";

export type FacilitySettingsRouteParams = Readonly<{
  facilityId: string;
}>;

export const useFacilitySettingsParams = () =>
  useParams<FacilitySettingsRouteParams>();
